import React from 'react';
import { Button, PlusIcon, Text } from '@razorpay/blade/components';
import { EmptyListView } from 'components/ui/EmptyListView/EmptyListView';

interface EmptyStateProps {
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const EmptyState = ({ title, description, buttonText, onButtonClick }: EmptyStateProps) => {
  return (
    <EmptyListView
      title={title}
      description={<Text color="surface.text.gray.muted">{description}</Text>}
      height="100%">
      {buttonText && onButtonClick && (
        <Button icon={PlusIcon} onClick={onButtonClick} size="large">
          {buttonText}
        </Button>
      )}
    </EmptyListView>
  );
};

export { EmptyState };

